<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.492 10.162 23.235 0h-2.072l-7.591 8.824L7.509 0H.516l9.168 13.343L.516 24h2.072l8.016-9.318L17.007 24H24l-9.508-13.838zm-2.837 3.299-.93-1.329L3.336 1.56h3.182l5.964 8.532.93 1.329 7.753 11.09h-3.182l-6.327-9.05z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
